/**
 * Czy box dnia da się wiarygodnie zmierzyć.
 * Ukryty oryginał (display:none / visibility:hidden) ma zerową geometrię —
 * pomiar wtedy zapisuje scale≈0 i po zamknięciu zoomu wydarzenia „znikają”.
 */
export function isLayoutBoxMeasurable(box) {
    if (!box) return false;

    let el = box;
    while (el) {
        const inline = el.style;
        if (inline && (inline.display === 'none' || inline.visibility === 'hidden')) {
            return false;
        }
        if (typeof window !== 'undefined' && typeof window.getComputedStyle === 'function') {
            try {
                const cs = window.getComputedStyle(el);
                if (cs.display === 'none' || cs.visibility === 'hidden') return false;
            } catch {
                // jsdom / detached node
            }
        }
        el = el.parentElement;
    }

    if (typeof box.clientWidth === 'number' && box.clientWidth <= 0) return false;
    return true;
}
